import logger from '../../services/logging/logging-service';
import { isMobile } from '../../utils/device-utils';
import { insertAfter } from '../../utils/dom-utils';
import {
  createInsDataNode,
  getAdvData,
  globalReviveAsync,
  initAdvLabels,
  setAdvInsertedState,
} from '../../utils/adv-helper';

const SMALL_BOTTOM_SPACING_CLASSNAME = 'l-spacing-s';

/**
 * Inject new adv inread with video
 * @param {HTML Node} advTopDataNode
 * @param {HTML Node} paragraph
 */
const injectAdvVideoInRead = (advInReadDataNode, paragraph) => {
  logger.info('[ADV ARTICLE] start video in read adv init');
  const { reviveId, zoneId } = getAdvData(advInReadDataNode);
  const $insDataNode = createInsDataNode(reviveId, zoneId);
  paragraph.classList.add(SMALL_BOTTOM_SPACING_CLASSNAME);
  insertAfter(paragraph, $insDataNode);
  const $script = document.createElement('script');
  $script.setAttribute('src', '//adx.4strokemedia.com/www/delivery/asyncjs.php');
  $script.setAttribute('async', true);
  insertAfter($insDataNode, $script);
  setAdvInsertedState(advInReadDataNode);
  logger.info('[ADV ARTICLE] $insDataNode, $script', $insDataNode, $script);
};

/**
 * Inject adv top in article pages
 * @param {HTML Node} advTopDataNode
 * @param {HTML Node} paragraph
 */
const injectAdvTopArticle = (advTopDataNode, paragraph) => {
  logger.info('[ADV ARTICLE] init adv-article');
  const { reviveId, zoneId } = getAdvData(advTopDataNode);
  const $insDataNode = createInsDataNode(reviveId, zoneId);

  if (isMobile()) {
    logger.info('[ADV ARTICLE] inject adv on mobile and move it after the 1st paragraph');
    const advTopMobileNode = document.querySelector('#adv-mpu-top-mobile');
    const advTopMobileDataNode = document.querySelector('#advTopMobile');
    insertAfter(paragraph, advTopMobileNode);
    advTopMobileDataNode.appendChild($insDataNode);
  } else {
    logger.info('[ADV ARTICLE] inject adv on desktop');
    const advTopDesktopDataNode = document.querySelector('#adv-top');
    advTopDesktopDataNode.appendChild($insDataNode);
  }
  setAdvInsertedState(advTopDataNode);

  globalReviveAsync(reviveId);
};

export const initAdvArticle = (advTopDataNode, advInReadDataNode) => {
  initAdvLabels();

  const paragraphNodes = document.querySelectorAll('.j-article-section p');
  const paragraphs = Array.from(paragraphNodes).filter((item) => {
    return item.innerHTML.length > 0;
    // TODO: Fix to avoid paragraphs containing white spaces only
    // return item.textContent.trim().length > 0;
  });

  if (advTopDataNode && paragraphs.length) {
    const firstParagraph = paragraphs[0];
    injectAdvTopArticle(advTopDataNode, firstParagraph);
  }

  if (advInReadDataNode && paragraphs.length > 2) {
    const secondParagraph = paragraphs[1];
    injectAdvVideoInRead(advInReadDataNode, secondParagraph);
  }
};
